import { render, staticRenderFns } from "./ServiceRequestView.vue?vue&type=template&id=e56e20ee&"
import script from "./ServiceRequestView.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports